var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"disabled":_vm.disabled,"multiple":_vm.multiple,"clearable":"","filterable":"","value":_vm.data,"placeholder":"请选择"},on:{"change":_vm.handleChange}},_vm._l((_vm.cityList),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.name,"value":item.name}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-221ea653","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/AddressSelect/City.vue
// module id = null
// module chunks = 